/**
 * Build-time SDK version constant. Phase 13.16.
 *
 * The SDK ships this in `/v1/collect` payloads (`sdk_version` field) so
 * the server can record which build produced each observation. Used for:
 *
 *   - Deprecation planning ("what % of traffic is still on pre-3.3.0?")
 *   - Targeted debugging ("customer X is on 3.0.0, that predates the v6
 *     UA-spoof fix")
 *   - Security incident response ("vuln landed in 3.1.x, who's exposed")
 *
 * Single source of truth: this file. Must be bumped in lockstep with
 * `sdk/package.json` "version" — bin/build check (TODO) or simply remember.
 * If they drift, the column in observations.sdk_version is slightly stale
 * but nothing breaks.
 */
export const SDK_VERSION = "3.3.1";
